export default "__VITE_ASSET__$HFvvwLe__"